import { Component } from '@angular/core';
import { Observable, interval } from 'rxjs';
import { AuthService } from '../app/services/auth.service';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { environment } from './../environments/environment';

import { Login } from './login/login';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ConfiguracaoService } from './services/configuracao.service';
import { NotificacaoService } from './services/notificacao.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  ano = new Date().getFullYear();
  empresa_rodape = '';
  versao_aplicacao = environment.versao;
  isCollapsed = false;
  infoUsuario = {
    name: ''
  };  
  showMenu: boolean = false;
  loading= false;

  notificacoes = [];
  notificacoesPendente = false;
  visibleConfiguracao = false;

  constructor(
    private authService: AuthService,
    private message: NzMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NzNotificationService,
    private notificacaoService: NotificacaoService,
    private configuracaoService: ConfiguracaoService,
  ) {

    /**
     * Toda vez que mudar de rota executa essa operação
     */
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
 
        if (event['url'].substring(0, 6) == '/login') {
          this.showMenu = false;
        } else {
          this.notificacaoService.all().subscribe((n: any) => {
            this.notificacoes = n.data.notificacoes.data;
            this.checkNotificacoesPendentes();
          }, (err: any) => {
            this.showMenu = false;
            this.router.navigate(['/login']);
          });
          this.showMenu = true;

          if (!localStorage.getItem('info') || this.infoUsuario === null) {
            this.authService.me().subscribe((m: any) => {
              let save = new Login();
              save.setInfoUsuario(m);
              this.infoUsuario = save.getInfoUsuario()[0];

            }, (err: any) => {
              this.showMenu = false;
              this.router.navigate(['/login']);
            });
          }
        }
      }
    });

  }

  ngOnInit() {
    if (localStorage.getItem('token')) {
      this.authService.me().subscribe((m: any) => {
        let save = new Login();
        save.setInfoUsuario(m);
        this.infoUsuario = save.getInfoUsuario();
      }, (err: any) => {
        this.showMenu = false;
        this.router.navigate(['/login']);
      });
    }

    this.configuracaoService.detalhar().subscribe((c: any) => {
      this.empresa_rodape = c.data.configuracao.nome_fantasia;
    });
  }

  deslogar() {
    this.authService.deslogar().subscribe((m: any) => {
      let save = new Login();
      save.logout();
      this.message.success('Você foi deslogado com SUCESSO!');
      this.router.navigate(['/login']);
    });
  }

  checkNotificacoesPendentes() {
    let novasNotificacao = this.notificacoes.filter(n => n.lido === 0);
    if (novasNotificacao.length > 0) {
      this.notificacoesPendente = true;
    } else {
      this.notificacoesPendente = false;
    }

  }

  abrirNotificacoes() {
    const checkLidos = [];

    let novasNotificacao = this.notificacoes.filter(n => n.lido === 0);
    novasNotificacao.forEach(n => {
      checkLidos.push(
        n.idnotificacao
      );
    });
    this.notificacaoService.lido(checkLidos).subscribe(n => {
      this.notificacoesPendente = false;
      this.notificacaoService.all().subscribe((n: any) => {
        this.notificacoes = n.data.notificacoes.data;
        this.checkNotificacoesPendentes();
      }, (err: any) => {
        this.showMenu = false;
        this.router.navigate(['/login']);
      });
    });
  }
}
